import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

interface DataInput {
  message: string
}
@Component({
  selector: 'app-confirm-resign-ekyc-support',
  templateUrl: './confirm-resign-ekyc-support.component.html',
  styleUrls: ['./confirm-resign-ekyc-support.component.scss']
})
export class ConfirmResignEkycSupportComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmResignEkycSupportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataInput
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
  }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close();
  }

}
